{
  "name": "group-sales-portal",
  "version": "2.9.0",
  "packageManager": "pnpm@11.5.2",
  "scripts": {
    "postinstall": "pnpm exec ng cache clean",
    "build-dev": "ng build --configuration development --aot --output-hashing=all",
    "build-pre": "ng build --configuration preproduction --aot --output-hashing=all",
    "build-pro": "ng build --configuration production --aot --output-hashing=all",
    "build": "ng build",
    "e2e:setup": ". ./cypress/scripts/.setenv.sh && node cypress/scripts/fetch-events-data.cjs",
    "cy:local:run": "pnpm run e2e:setup && . ./cypress/scripts/.setenv.sh && npx cypress run -C cypress/config/cypress.local.cjs",
    "cy:local": "pnpm run e2e:setup && . ./cypress/scripts/.setenv.sh && npx cypress open -C cypress/config/cypress.local.cjs --e2e",
    "cy:run": "pnpm run e2e:setup && . ./cypress/scripts/.setenv.sh && npx cypress run -C cypress/config/cypress.ci.cjs",
    "cy:smoke": "pnpm run e2e:setup && . ./cypress/scripts/.setenv.sh && npx cypress run -C cypress/config/cypress.ci.cjs --spec 'cypress/e2e/smoke.cy.ts'",
    "cy": "pnpm run e2e:setup && . ./cypress/scripts/.setenv.sh && npx cypress open -C cypress/config/cypress.ci.cjs --e2e",
    "lint": "ng lint",
    "ng": "ng",
    "start:dev": "ng serve --host local.3ddigitalvenue.com --port 4200 --open --configuration development",
    "start:local:chicagocubs:ssl": "ng serve --host local.chicagocubs.3ddigitalvenue.com --open --port 4200 --configuration local --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key'",
    "start:local:chicagocubs": "ng serve --host local.chicagocubs.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:chicagocubsspring": "ng serve --host local.chicagocubsspring.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:chicagocubsspring:ssl": "ng serve --host local.chicagocubsspring.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:local:miamimarlins": "ng serve --host local.miamimarlins.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:miamimarlins:ssl": "ng serve --host local.miamimarlins.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:local:pittsburghpirates": "ng serve --host local.pittsburghpirates.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:pittsburghpirates:ssl": "ng serve --host local.pittsburghpirates.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:local:redsox": "ng serve --host local.redsox.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:redsox:ssl": "ng serve --host local.redsox.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:local:washingtonnationals": "ng serve --host local.washingtonnationals.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:washingtonnationals:ssl": "ng serve --host local.washingtonnationals.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:local:houstonastros": "ng serve --host local.houstonastros.3ddigitalvenue.com --open --port 4200 --configuration local",
    "start:local:houstonastros:ssl": "ng serve --host local.houstonastros.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration local",
    "start:dev:chicagocubs": "ng serve --host local.chicagocubs.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:chicagocubsspring": "ng serve --host local.chicagocubsspring.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:houstonastros": "ng serve --host local.houstonastros.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:miamimarlins": "ng serve --host local.miamimarlins.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:pittsburghpirates": "ng serve --host local.pittsburghpirates.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:redsox": "ng serve --host local.redsox.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:dev:washingtonnationals": "ng serve --host local.washingtonnationals.3ddigitalvenue.com --open --port 4200 --configuration development",
    "start:pre:astros": "ng serve --host local.houstonastros.3ddigitalvenue.com --port 4200 --open --configuration preproduction",
    "start:pre:chicagocubs": "ng serve --host local.chicagocubs.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:chicagocubs:ssl": "ng serve --host local.chicagocubs.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration preproduction",
    "start:pre:chicagocubsspring": "ng serve --host local.chicagocubsspring.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:houstonastros": "ng serve --host local.houstonastros.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:miamimarlins": "ng serve --host local.miamimarlins.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:pittsburghpirates": "ng serve --host local.pittsburghpirates.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:redsox": "ng serve --host local.redsox.3ddigitalvenue.com --port 4200 --open --configuration preproduction",
    "start:pre:ssl": "ng serve --host local.3ddigitalvenue.com --port 4200 --open --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration preproduction",
    "start:pre:washingtonnationals": "ng serve --host local.washingtonnationals.3ddigitalvenue.com --open --port 4200 --configuration preproduction",
    "start:pre:washingtonnationals:ssl": "ng serve --host local.washingtonnationals.3ddigitalvenue.com --open --port 4200 --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration preproduction",
    "start:pre": "ng serve --host local.3ddigitalvenue.com --port 4200 --open --configuration preproduction",
    "start:prod": "ng serve --host local.3ddigitalvenue.com --port 4200 --open --configuration production",
    "start:prod:chicagocubs:ssl": "ng serve --host local.chicagocubs.3ddigitalvenue.com --port 4200 --open --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' --configuration production",
    "start:prod:pittsburghpirates": "ng serve --host local.pittsburghpirates.3ddigitalvenue.com --open --port 4200 --configuration production",
    "start:ssl": "ng serve --host local.3ddigitalvenue.com --port 4200 --opnppen --ssl true --ssl-cert 'ssl/server.crt' --ssl-key 'ssl/server.key' ",
    "test": "ng test --code-coverage --watch=false",
    "watch": "ng build --watch --configuration development",
    "deps:update": "./update-deps.sh 30"
  },
  "private": true,
  "dependencies": {
    "@3ddv/dvm-internal": "2.7.8",
    "@3ddv/ngx-dvm-internal": "^4.2.6",
    "@3ddv/software-division-components": "^1.3.0",
    "@3ddv/ticketing-config": "^1.1.2",
    "@angular/animations": "^21.1.0",
    "@angular/cdk": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/material": "21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@floating-ui/dom": "^1.7.4",
    "@ng-icons/core": "^33.0.0",
    "@ng-icons/lucide": "^33.0.0",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/http-client": "^7.0.1",
    "@okta/okta-angular": "^7.0.0",
    "@okta/okta-auth-js": "^7.14.1",
    "@popperjs/core": "^2.11.8",
    "@spartan-ng/brain": "0.0.1-alpha.499",
    "@tanstack/angular-table": "^8.21.3",
    "animejs": "4.2.2",
    "axios": "^1.13.2",
    "class-variance-authority": "^0.7.1",
    "driver.js": "^1.4.0",
    "luxon": "^3.7.2",
    "ngx-bootstrap": "~20.0.2",
    "ngx-device-detector": "~11.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zod": "^4.2.1",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/schematics": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@tailwindcss/postcss": "^4.1.18",
    "@testing-library/cypress": "^10.1.0",
    "@types/animejs": "3.1.13",
    "@types/braintree-web-drop-in": "^1.39.4",
    "@types/jasmine": "~5.1.13",
    "@types/luxon": "^3.7.1",
    "@types/node": "^25.0.3",
    "@typescript-eslint/eslint-plugin": "^8.50.0",
    "@typescript-eslint/parser": "^8.50.0",
    "angular-http-server": "^1.12.0",
    "autoprefixer": "^10.4.23",
    "cypress": "^15.8.1",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jasmine-core": "~5.13.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "~8.5.6",
    "prettier": "^3.7.4",
    "prettier-eslint": "^16.4.2",
    "rimraf": "~6.1.2",
    "tailwindcss": "^4.1.18",
    "typescript": "~5.9.3"
  }
}
